// @ts-nocheck
import { createSlice } from "@reduxjs/toolkit";
import {
  hashFineractPublicAuthorizationAction,
  logoutAction,
} from "./StoreActions";
import {
  nimblex360LoginApi,
  sequestLoginApi,
} from "login/LoginStoreQuerySlice";
import { EnvKeys } from "constants/EnvKeys";
import CryptoJS from "crypto-js";

export const globalInitialState = {
  isSideMenu: false,
  isDocumentPreviewSideMenu: false,
  isSideMenuTemporary: false,
  isLoadingModal: false,
  authUser: null,
};

const slice = createSlice({
  name: "global",
  initialState: globalInitialState,
  reducers: {
    toggleSideMenuAction: (state, { payload }) => {
      state.isSideMenu = payload !== undefined ? !!payload : !state.isSideMenu;
    },
    toggleDocumentPreviewSideMenuAction: (state, { payload }) => {
      state.isDocumentPreviewSideMenu =
        payload !== undefined ? !!payload : !state.isDocumentPreviewSideMenu;
    },
    toggleSideMenuTemporaryAction: (state, { payload }) => {
      state.isSideMenuTemporary =
        payload !== undefined ? !!payload : !state.isSideMenuTemporary;
    },
    toggleLoadingModalAction: (state, { payload }) => {
      state.isLoadingModal =
        payload !== undefined ? !!payload : !state.isLoadingModal;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(logoutAction, () => ({ ...globalInitialState }))
      .addCase(hashFineractPublicAuthorizationAction, (state, { payload }) => {
        let message = payload.processId + EnvKeys.FINERACT_PUBLIC_API_KEY;
        if (payload.clientId) {
          message = message + payload.clientId;
        }
        state.fineractPublicAuthorizationHash = payload
          ? CryptoJS.HmacSHA256(
              message,
              EnvKeys.FINERACT_PUBLIC_API_KEY_HASHING
            ).toString()
          : globalInitialState.fineractPublicAuthorizationHash;
        state.processId = payload?.processId || state.processId;
      })
      .addMatcher(
        nimblex360LoginApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          state.authUser = payload;
        }
      )
      .addMatcher(
        sequestLoginApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          state.authUser.sequest = payload;
        }
      )
      .addMatcher(
        nimblex360LoginApi.endpoints.getLoginOTPDeliveryMethods.matchFulfilled,
        (state, { payload }) => {
          state.authUser.otpDeliveryMethods = payload;
          state.authUser.normalizedOtpDeliveryMethods = payload.reduce(
            (acc, curr) => {
              acc[curr.name] = curr;
              return acc;
            },
            {}
          );
        }
      )
      .addMatcher(
        nimblex360LoginApi.endpoints.requestLoginOTP.matchFulfilled,
        (state, { payload }) => {
          state.authUser.otpRequest = payload;
        }
      )
      .addMatcher(
        nimblex360LoginApi.endpoints.resendLoginOTP.matchFulfilled,
        (state, { payload }) => {
          state.authUser.otpRequest = payload;
        }
      )
      .addMatcher(
        nimblex360LoginApi.endpoints.validateLoginOTP.matchFulfilled,
        (state, { payload }) => {
          state.authUser.tfaToken = payload;
        }
      )
      .addMatcher(
        nimblex360LoginApi.endpoints.getAuthUserProfile.matchFulfilled,
        (state, { payload }) => {
          Object.assign(state.authUser, payload, {
            fullname: `${payload?.firstname} ${payload?.lastname}`,
          });
        }
      ),
});

export const {
  toggleSideMenuAction,
  toggleLoadingModalAction,
  toggleSideMenuTemporaryAction,
  toggleDocumentPreviewSideMenuAction,
} = slice.actions;

export default slice;

export function getGlobalSliceStorageState({ authUser }) {
  // if (process.env.NODE_ENV !== "production") {
  //   return { authUser };
  // }
  // return {};
  return { authUser };
}
